/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from '@/config/backend'

const CACHE_TTL = 5 * 60 * 1000

function isFresh(ts) {
    return ts && Date.now() - ts < CACHE_TTL
}

function periodParams(period) {
    if (!period || !period.from || !period.to) return {}
    return { from: period.from, to: period.to }
}

export default {
    async fetchCatalog({ rootState, state, commit }, { force = false } = {}) {
        if (!force && state.catalog && isFresh(state.catalogFetchedAt)) {
            return state.catalog
        }
        const res = await axios.get(`${rootState.baseURL}/statistics/catalog`)
        const catalog = (res.data && res.data.metrics) || []
        commit('SET_CATALOG', catalog)
        return catalog
    },

    async fetchDashboard({ rootState, state, commit }, { force = false } = {}) {
        if (!force && state.dashboard && isFresh(state.dashboardFetchedAt)) {
            return state.dashboard
        }
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        try {
            const res = await axios.get(`${rootState.baseURL}/statistics/dashboard`, {
                params: periodParams(state.period)
            })
            commit('SET_DASHBOARD', res.data)
            return res.data
        } catch (e) {
            commit('SET_ERROR', e)
            throw e
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchMetrics({ rootState, state }, { ids }) {
        if (!ids || !ids.length) return { ids: [], metrics: {} }
        const res = await axios.get(`${rootState.baseURL}/statistics/metrics`, {
            params: { ids: ids.join(','), ...periodParams(state.period) }
        })
        return res.data
    },

    async fetchConfig({ rootState, commit }) {
        const res = await axios.get(`${rootState.baseURL}/statistics/dashboard/config`)
        commit('SET_CONFIG', res.data)
        return res.data
    },

    async updateConfig({ rootState, commit }, ids) {
        commit('SET_SAVING', true)
        try {
            const res = await axios.put(`${rootState.baseURL}/statistics/dashboard/config`, { ids })
            commit('SET_CONFIG', res.data)
            commit('INVALIDATE_DASHBOARD')
            return res.data
        } finally {
            commit('SET_SAVING', false)
        }
    },

    setPeriod({ commit }, period) {
        commit('SET_PERIOD', period)
        commit('INVALIDATE_DASHBOARD')
    }
}
